import { Component } from "react";
import { connect } from "react-redux";
import ItemsSelect from "./itemsSelect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import {
  setSelectedItem,
  addNewItemToOrder,
} from "../redux-state/features/orderState";
import { showError } from "../utils/notifications";
// to generate unique ids for order items
import { v4 as uuidv4 } from "uuid";

class ItemsForm extends Component {
  constructor() {
    super();
    this.state = {
      quantity: 1,
    };
  }

  handleQuantityChange = (event) => {
    const value = parseInt(event.target.value, 10);
    if (!isNaN(value) && value >= 1) {
      this.setState({ quantity: value });
    }
  };
  handleAddNew = () => {
    console.log("--->", this.props.options);
    const selectedItem = this.props.options;
    if (selectedItem === null) {
      const msg = "يجب إختيار السلعة قبل الإضافة ";
      showError(msg);
      return;
    }

    const { available_quantity, label, value } = selectedItem;
    const { quantity } = this.state;
    // check quantity selected with quantity in stock
    if (quantity > available_quantity) {
      const msg = "الكمية المطلوبة غير متاحة في المخزن ";
      showError(msg);
      return;
    }
    const orderId = uuidv4();
    //orderItem
    const orderItem = {
      orderId,
      orderItem: label,
      itemId: value,
      quantity,
      available_quantity,
    };
    this.props.addNewItemToOrder({ orderItem });
    console.log(orderItem);
    // clear selected item
    this.props.setSelectedItem(null);
  };
  render() {
    const { quantity } = this.state;

    return (
      <div className="container-fluid border border-1 rounded-2 p-2 mb-3">
        <div className="row">
          <div className="col-6">
            <label>التعيين</label>
          </div>
          <div className="col-2">
            <label>العدد </label>
          </div>
        </div>
        <div className="row  g-3 align-items-center">
          <div className="col-6">
            <ItemsSelect />
          </div>
          <div className="col-2">
            {/* <button
                className="btn btn-outline-secondary me-2"
                onClick={this.handleDecrement}
              >
                -
              </button> */}
            <input
              type="number"
              className="form-control text-center"
              id="exampleFormControlInput1"
              value={quantity}
              onChange={this.handleQuantityChange}
              min={1}
            />
            {/* <button
                className="btn btn-outline-secondary ms-2"
                onClick={this.handleIncrement}
              >
                +
              </button> */}
          </div>
          <div className="col-3 ">
            <button
              className="btn btn-outline-warning ms-2  "
              style={{ height: "38px", width: "140px" }}
              onClick={this.handleAddNew}
            >
              <FontAwesomeIcon icon={faPlus} />
              <span className="ms-3">إضافة</span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = { setSelectedItem, addNewItemToOrder };
const mapStateToProps = (state) => ({
  options: state.orderState.selectedItem,
});
export default connect(mapStateToProps, mapDispatchToProps)(ItemsForm);
